<template>
    <div>
      <Head title="Reports" />
      <h1 class="mb-8 text-3xl font-bold">Outbound Links<downloadexcel
            :data="jobs"
            :fields="job_fields"
          >
            <v-btn large color="primary">Download <v-icon>mdi-download</v-icon></v-btn>
          </downloadexcel></h1>
      
          
          <v-data-table
            :items="jobs"
            :headers="headers"
          >
          <template v-slot:item.status="{ item }">
                <v-icon v-if="item.status == 1" color="success">mdi-check</v-icon>
                <v-icon v-else color="error">mdi-close-circle-outline</v-icon>
            </template> 

          </v-data-table> 
      
    </div>
  </template>
  
  <script>
  import { Head } from '@inertiajs/inertia-vue'
  import { Link } from '@inertiajs/inertia-vue'
    import Layout from '@/Shared/VuetifyAdminLayout'
    import axios from 'axios'
    import downloadexcel  from "vue-json-excel";

  export default {
    components: {
      Head,
      downloadexcel,
      Link
    },
    props: {
      jobs: Array
      },
    /*computed: {
      reducedJobs() {
        let rj = JSON.parse(JSON.stringify(jobs));
        for(i=0;i<jobs.length;i++)
        {
          rj[i].organization_id = 
        }
      }
    },*/
    data: () => ({
      headers: [
              { text:'Org ID', value:'organization.id'},
              { text:'Org Name', value:'organization.name'},
              { text: 'ID', value:'id'},
              { text: 'Category', value:'category.title'},
              { text: 'Title', value:'title'},
              { text: 'Region', value:'region'},
              { text: 'Start date', value:'start_publishing'},
              { text: 'Active', value:'status'},
              { text: 'Hits', value: 'hits'},
              { text: 'Applications', value:'applications_count'},
              { text: 'Favorites', value:'favorites_count'},
              { text: 'External Visits', value:'ext_hits'}
        ],
        job_fields: {
          "Org ID": "organization.id",
          "Org Name":"organization.name",
          "ID":"id",
          "Category":"category.title",
          "Title":"title",
          "Region":"region",
          "Start date":"start_publishing",
          "Active":"status",
          "Hits": "hits",
          "Applications":"applications_count",
          "Favorites":"favorites_count",
          "External Visits":"ext_hits"
      },
    }),
    layout: Layout,
  }
  </script>
  
  <style scoped>
    .v-sheet--offset {
      top: -24px;
      position: relative;
    }
  </style>